import { FC } from 'react';
import { SidePanel } from '../side-panel';
import { SidePanelLayout } from '../side-panel-layout/side-panel-layout.component';
import { sharedTypes } from '../../../../lib/api/models/umbraco';
import { StyledCloseCta } from './modal-with-editor-content.styled';
import { GenericModalContentRender } from './generic-modal-content';

export type GenericModalContent = {
    header: string;
    description: string;
    mediaList: Array<{ caption: string; media: sharedTypes.Image | sharedTypes.Video }>;
};

type IProps = {
    onClose: () => void;
    visible: boolean;
    content: GenericModalContent;
    closeCta?: boolean;
};

export const ModalWithEditorContent: FC<IProps> = ({ onClose, visible, content, closeCta = false }) => {
    return (
        <SidePanel cancelAction={onClose} isVisible={visible}>
            <SidePanelLayout closeSidePanel={onClose}>
                <GenericModalContentRender {...content} />
                {closeCta ? (
                    <StyledCloseCta variant="primary" onClick={onClose}>
                        Luk
                    </StyledCloseCta>
                ) : null}
            </SidePanelLayout>
        </SidePanel>
    );
};
